// Remove unused ESLint rule and fix linter errors
// import { MAIN_LINKS } from "@/constant/links";
import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Container from "./../ui/container";
import Service from "./../ServiceComponent/Service";

import logo from "./../assets/images/logo-fill-icon.webp";
import logoText from "./../assets/images/logo-text.webp";
import "../css/navbar.css";
const RightSidebar = React.lazy(() => import("./rigth-sidebar"));

const Navbar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const serviceRef = useRef(null);
  const serviceButtonRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const serviceNode = serviceRef.current;
      const buttonNode = serviceButtonRef.current;

      if (
        serviceNode &&
        !serviceNode.contains(event.target) &&
        buttonNode &&
        !buttonNode.contains(event.target)
      ) {
        setShowServices(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [serviceRef, serviceButtonRef, setShowServices]);

  return (
    <>
      <RightSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className={`navbar-sticky${scrolled ? " navbar-scrolled" : ""}`}>
        <Container className='navbar-container'>
          <Link to='/' className='navbar-logo-link'>
            <div className='navbar-logo-group'>
              <div className='navbar-logo-img-wrapper'>
                <img src={logo} alt='logo' className='navbar-logo-img' />
              </div>
              <div className='navbar-logo-text-wrapper'>
                <img
                  src={logoText}
                  alt='logo'
                  className='navbar-logo-text-img'
                />
              </div>
            </div>
          </Link>
          <div className='navbar-links-group'>
            <div className='navbar-links'>
              <Link
                to='/'
                className={`navbar-link${
                  pathname === "/" || (pathname.includes("/") && "/" !== "/")
                    ? " navbar-link-active"
                    : ""
                }`}
              >
                <span className='navbar-link-text'>Home</span>
              </Link>
              <button
                ref={serviceButtonRef}
                onClick={() => setShowServices(!showServices)}
                className={`navbar-link${
                  pathname === "/services" || pathname.includes("/services")
                    ? " navbar-link-active"
                    : ""
                }`}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  padding: "0",
                  margin: "0",
                  marginTop:"-7px"
                }}
              >
                <span className='navbar-link-text'>Services</span>
              </button>
              <Link
                to='/aboutus'
                className={`navbar-link${
                  pathname === "/aboutus" || pathname.includes("/aboutus")
                    ? " navbar-link-active"
                    : ""
                }`}
              >
                <span className='navbar-link-text'>About Us</span>
              </Link>
              <Link
                to='/parts-and-supplies'
                className={`navbar-link${
                  pathname === "/parts-and-supplies" ||
                  pathname.includes("/parts-and-supplies")
                    ? " navbar-link-active"
                    : ""
                }`}
              >
                <span className='navbar-link-text'>Parts & Supplies</span>
              </Link>
              <Link
                to='/contactus'
                className={`navbar-link${
                  pathname === "/contactus" || pathname.includes("/contactus")
                    ? " navbar-link-active"
                    : ""
                }`}
              >
                <span className='navbar-link-text'>Contact</span>
              </Link>
            </div>
            <div className='navbar-menu-btn-group'>
              <button
                className='navbar-menu-btn'
                onClick={() => setIsOpen(true)}
              >
                <span className='navbar-menu-bar navbar-menu-bar-top'></span>
                <span className='navbar-menu-bar navbar-menu-bar-mid'></span>
                <span className='navbar-menu-bar navbar-menu-bar-bot'></span>
              </button>
            </div>
          </div>
        </Container>
      </div>

      {showServices && (
        <div ref={serviceRef} className='navbar-services-dropdown'>
          <Service setShowServices={setShowServices} />
        </div>
      )}
    </>
  );
};

export default Navbar;
